import { useEffect } from "react";

const SITE = "https://algoforge.tech";
const DEFAULT_IMG = `${SITE}/og-default.png`;

export default function SEOMeta({
  title,
  description,
  image,
  url,
  type = "website",
  publishedAt,
  author,
  keywords,
}) {
  const fullTitle = title ? `${title} | AlgoForge` : "AlgoForge — AI Algo Trading Platform for Indian Traders";
  const desc = description || "Automate your trading strategies, backtest on NSE/BSE data, and trade with discipline. Free paper trading + options intelligence for Indian retail traders.";
  const img = image || DEFAULT_IMG;
  const canonical = url ? `${SITE}${url}` : SITE;

  useEffect(() => {
    document.title = fullTitle;
    setMeta("description", desc);
    setMeta("keywords", keywords || "algo trading india, options strategy calculator, nifty trading automation, zerodha automated trading, paper trading india, iv rank options india");

    // Open Graph
    setOG("title", fullTitle);
    setOG("description", desc);
    setOG("image", img);
    setOG("url", canonical);
    setOG("type", type);
    setOG("site_name", "AlgoForge");

    // Twitter Card
    setTwitter("card", "summary_large_image");
    setTwitter("title", fullTitle);
    setTwitter("description", desc);
    setTwitter("image", img);
    setTwitter("site", "@AlgoForgeIndia");

    // Article schema
    if (type === "article" && publishedAt) {
      setMeta("article:published_time", publishedAt);
      if (author) setMeta("article:author", author);
    }

    // Canonical
    let link = document.querySelector("link[rel='canonical']");
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", canonical);
  }, [fullTitle, desc, img, canonical, type, publishedAt, author, keywords]);

  return null;
}

function setMeta(name, content) {
  if (!content) return;
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setOG(property, content) {
  if (!content) return;
  let el = document.querySelector(`meta[property="og:${property}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("property", `og:${property}`);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setTwitter(name, content) {
  if (!content) return;
  let el = document.querySelector(`meta[name="twitter:${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", `twitter:${name}`);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}
